module.exports = __webpack_public_path__ + "img/credit.582c5a84.png";